import { useLocation } from 'react-router-dom';
import { Bell, Search } from 'lucide-react';
import { useTaxStore } from '@/store/taxStore';

const pageNames: Record<string, string> = {
  '/': 'Dashboard',
  '/documents': 'Documents',
  '/businesses': 'Businesses',
  '/investments': 'Investments',
  '/deductions': 'Deductions',
  '/tax-summary': 'Tax Summary',
  '/settings': 'Settings',
};

export function Header() {
  const location = useLocation();
  const { selectedYear } = useTaxStore();
  const pageName = pageNames[location.pathname] || 'TaxVault';

  return (
    <header className="h-16 border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-10">
      <div className="h-full px-6 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold">{pageName}</h1>
          <p className="text-sm text-muted-foreground">Tax Year {selectedYear}</p>
        </div>

        <div className="flex items-center gap-4">
          {/* Search */}
          <div className="relative hidden md:block">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <input
              type="text"
              placeholder="Search..."
              className="w-64 pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          {/* Notifications */}
          <button className="relative p-2 rounded-lg hover:bg-accent transition-smooth">
            <Bell className="h-5 w-5 text-muted-foreground" />
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-primary" />
          </button>
        </div>
      </div>
    </header>
  );
}
